import { DetailDescriptionDataSource } from '../DetailDescriptionDataSource';
import { DetailTranslationKeys, ErrorTranslationKeys } from '../../../api/models/TranslationKeys';
import { BundleAsset } from './BundleAsset';
import { Backend } from '../../../api/Backend';
import { IDetailDescription } from '../detail.types';

export class BundleDetailDescriptionDataSource extends DetailDescriptionDataSource {
  private content: BundleAsset;
  constructor(content: BundleAsset, contentType: string, backend: Backend) {
    super(content.bundle.id, contentType, backend);
    this.content = content;
  }

  override load(): Promise<IDetailDescription> {
    return this._getDetailDescription(this.content);
  }

  _getDetailDescription(bundleAsset: BundleAsset): Promise<IDetailDescription> {
    const bundle = bundleAsset.bundle;
    const ageRating = this.getAgeratingIcon(bundle.minAge);
    return Promise.resolve({
      title: bundle.title,
      synopsis: bundle.synopsis,
      ageRating: ageRating ? { src: ageRating } : undefined,
      score: undefined,
      metaInformation: undefined,
      ...this.getSubscriptionPurchaseExpireInfo(bundleAsset),
      resolution: this.getResolutionIconFromStreams(
        this.backend.isAuthorized() ? bundleAsset.bundle.resolutions : bundleAsset.getAllResolutions()
      ),
      secondaryMetaInfo: undefined,
      credits: undefined,
      parentalControlIcons: undefined,
      bookmarkPercentage: undefined,
    } as IDetailDescription);
  }

  getSubscriptionPurchaseExpireInfo(bundleAsset: BundleAsset) {
    const result: {
      subscription: string | undefined;
      expire: string | undefined;
      pricing: string | undefined;
    } = {
      subscription: undefined,
      expire: undefined,
      pricing: undefined,
    };

    const lastValidQuote = bundleAsset.getLastValidQuote();

    if (lastValidQuote) {
      result.pricing = this.getAvailableUntilFromQuote(this.backend, lastValidQuote);
    } else if (bundleAsset.bundleIsExpired()) {
      result.expire = this.backend.translations.forKey(ErrorTranslationKeys.error_bundle_expired);
    } else if (bundleAsset.hasSvodResolution()) {
      result.subscription = this.backend.translations.forKey(DetailTranslationKeys.detail_included_in_subscriptions);
    } else if (bundleAsset.hasFvodResolution()) {
      result.pricing = this.backend.translations.forKey(DetailTranslationKeys.detail_free_to_watch);
    } else {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      result.pricing = this.getPricingInfo(bundleAsset.rentableBundleResolutions);
    }

    return result;
  }
}
